import { useTranslation } from '@frontend/i18n';
import { Button, Modal, Text } from '@frontend/design-system';
import { styles } from '../styles';

type FooterProps = {
  closeModal: () => void;
  selectedCount: number;
  onTextToPayClick: () => void;
};
export const Footer = ({ closeModal, selectedCount, onTextToPayClick }: FooterProps) => {
  const { t } = useTranslation('payments');

  return (
    <Modal.Footer>
      <div css={styles.validateUser.footer}>
        <Button variant='tertiary' onClick={closeModal} trackingId='bulk-collection-validate-users-close-button'>
          {t('Close')}
        </Button>
        <div css={styles.validateUser.footerActions}>
          <Text size='medium' css={styles.validateUser.footerSelectedCount}>
            {selectedCount} {t('selected')}
          </Text>
          <Button
            iconName='payment-request'
            variant='secondary'
            onClick={onTextToPayClick}
            disabled={selectedCount === 0}
            css={styles.validateUser.button}
            trackingId='bulk-collection-validate-users-text-to-pay-button'
          >
            {t('Text-to-Pay')}
          </Button>
        </div>
      </div>
    </Modal.Footer>
  );
};
